/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UIButton from 'UIComponents/button/UIButton';
import { DONE } from 'ui-shepherd-react/constants/TourStates';
import { TOUR_POPOVER_BOTTOM_MARGIN, TOUR_POPOVER_WIDTH_PX } from '../constants/UIConstants';
import { getOnboardingStep } from '../constants/Events';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class NewFeatureTourStep extends PureComponent {
  constructor(props) {
    super(props);
    this.handleBeforeStart = this.handleBeforeStart.bind(this);
    this.handleSkipTour = this.handleSkipTour.bind(this);
    this.handleTourComplete = this.handleTourComplete.bind(this);
  }
  handleBeforeStart() {
    const {
      stepKey
    } = this.props;
    trackEvent(getOnboardingStep({
      action: 'tour step',
      stepName: stepKey
    }));
  }
  handleSkipTour() {
    const {
      stepKey
    } = this.props;
    trackEvent(getOnboardingStep({
      action: 'skipped tour',
      stepName: stepKey
    }));
    this.context.tour.finish();
  }
  handleTourComplete() {
    this.props.trackEvent(getOnboardingStep({
      action: 'tour end',
      stepName: DONE
    }));
  }
  renderLastStepFooter() {
    return /*#__PURE__*/_jsx(UITourNextButton, {
      beforeNext: this.handleTourComplete,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.new-feature-onboarding.finishTour"
      })
    });
  }
  renderFooter() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UITourNextButton, {
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.new-feature-onboarding.nextTip"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: this.handleSkipTour,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.new-feature-onboarding.skipTour"
        })
      })]
    });
  }
  render() {
    const {
      stepKey,
      header,
      body,
      placement,
      width,
      children
    } = this.props;
    if (!this.context.tour) {
      return children;
    }
    const {
      steps
    } = this.context.tour.getConfig();
    const isLastStep = steps.indexOf(stepKey) === steps.length - 1;
    return /*#__PURE__*/_jsx(UITourStep, {
      className: "new-feature-tour-step",
      beforeStart: this.handleBeforeStart,
      stepKey: stepKey,
      content: {
        header: /*#__PURE__*/_jsx("h4", {
          children: header
        }),
        body: /*#__PURE__*/_jsx("div", {
          style: {
            marginBottom: TOUR_POPOVER_BOTTOM_MARGIN
          },
          children: /*#__PURE__*/_jsx("p", {
            children: body
          })
        }),
        footer: isLastStep ? this.renderLastStepFooter(steps) : this.renderFooter(steps)
      },
      placement: placement,
      width: width || TOUR_POPOVER_WIDTH_PX,
      children: Children.only(children)
    });
  }
}
NewFeatureTourStep.displayName = 'NewFeatureTourStep';
NewFeatureTourStep.propTypes = {
  body: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  placement: PropTypes.string.isRequired,
  stepKey: PropTypes.string.isRequired,
  width: PropTypes.number
};
NewFeatureTourStep.contextType = TourContext;